import { render, staticRenderFns } from "./selectSingleItemFromArray.vue?vue&type=template&id=243b3a92"
import script from "./selectSingleItemFromArray.vue?vue&type=script&lang=js"
export * from "./selectSingleItemFromArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports